import { render, staticRenderFns } from "./PublicKnowledgeMenu.vue?vue&type=template&id=91c8482e&scoped=true&"
import script from "./PublicKnowledgeMenu.vue?vue&type=script&lang=js&"
export * from "./PublicKnowledgeMenu.vue?vue&type=script&lang=js&"
import style0 from "./PublicKnowledgeMenu.vue?vue&type=style&index=0&id=91c8482e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c8482e",
  null
  
)

export default component.exports